// extracted by mini-css-extract-plugin
export default {"scrollTable":"_1RxdajMJeT2KGnOteKEynA","left":"_3q8lKaXOHr8U4akie-16TL","right":"fTmdH7ZW_x6B1R1YuYAkp","label":"_20I4n0tQ2rtHtp34H6gpQx"};